import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { B11aPaymentTypeAddPage } from '../b11a-payment-type-add/b11a-payment-type-add';
import { B11bPaymentTypeInfoPage } from '../b11b-payment-type-info/b11b-payment-type-info';
import { B11cPaymentTypeSubListPage } from '../b11c-payment-type-sub-list/b11c-payment-type-sub-list';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B11PaymentTypeManagementPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface paymentTypeInfo {
	PAYMENT_TYPE_ID: number;
	TYPE: string;
	AUTHORIZE: string;
	PAYMENT_TYPE_ACTIVE: string;
}

@IonicPage()
@Component({
	selector: 'page-b11-payment-type-management',
	templateUrl: 'b11-payment-type-management.html',
})
export class B11PaymentTypeManagementPage {
	
	loading: any;
	Status: any;
	paymentTypeArr: paymentTypeInfo[] = [];
	paymentTypeItems: paymentTypeInfo[] = [];
	public errorMessage: any = "";
	
	constructor(public navCtrl: NavController, public navParams: NavParams, 
				public serviceapi: ServiceApiProvider, public loadingCtrl: LoadingController) {
					
		let sortby= "No";
		let sorttype= "No";

		let tbl = ["All"];
		let column = ["All"];
		let value = ["All"];
		
		let tblkey = ["No"];
		let fktbl = ["No"];
		let fkkey = ["No"];
  
		let jsonsort = this.serviceapi.sort(sortby,sorttype);
		let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

		let mydata = Object.assign(jsonsort,jsonitem);
		let json_data = this.serviceapi.json_readdata(mydata,"1");
		this.showLoader();

		this.serviceapi.readdata(json_data,"PAYMENT_TYPE","1","1").then((result) => {
			this.Status = result["Message"];			
			if (this.Status == '1') {
				this.loading.dismiss();
				let Records = result["Records"];
				this.paymentTypeArr = Records;
				this.paymentTypeItems = this.paymentTypeArr;
			}
			else {
				this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
				this.loading.dismiss();
			}
		}, (err) => {
			this.errorMessage = "Loading Error. Please try again.";
			this.loading.dismiss();
		});		
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad B11PaymentTypeManagementPage');
	}
	
	goToAddPaymentType(){
		this.navCtrl.push(B11aPaymentTypeAddPage);
	}
	
	editPaymentType(ID){
		this.navCtrl.push(B11bPaymentTypeInfoPage, {paramID: ID});
	}
	
	viewPaymentSubType(ID){
		this.navCtrl.push(B11cPaymentTypeSubListPage, {paramID: ID});
	}

	showLoader() {
		this.loading = this.loadingCtrl.create({
			content: 'Loading...',
			//dismissOnPageChange: true,
		});
		this.loading.present();
	}
}



// WEBPACK FOOTER //
// ./src/pages/b11-payment-type-management/b11-payment-type-management.ts